// @flow

import React from "react";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import SortableItem from "./SortableItem";
import { SortableList as StyledSortableList } from "./styles";

type Props = {
  items: Array<string>,
  processLabels: Object,
  fields: Object,
  clearSort: Function,
};

const SortableList = ({ items, processLabels, fields, clearSort }: Props) => {
  return (
    <SortableContext items={items} strategy={verticalListSortingStrategy}>
      <StyledSortableList>
        {items.map((column, index) => (
          <SortableItem
            key={`item-${index}`}
            column={column}
            processLabels={processLabels}
            fields={fields}
            clearSort={clearSort}
          />
        ))}
      </StyledSortableList>
    </SortableContext>
  );
};

export default SortableList;
